<script lang="ts">
import { computed, defineComponent } from 'vue';
import * as CdsIcons from '@central-design-system/icons';

import { pascalCase } from '@components/utils';

import {
  makeInvertColor,
  makeSizeProps,
  makeThemeProps,
  provideTheme,
  useInvertColor,
  useSize
} from '../../composable';

import type { PropType } from 'vue';
import type { TCdsIconsName } from '@central-design-system/icons';

export const componentName = 'CdsIcon';
export default defineComponent({
  name: componentName,
  props: {
    name: {
      /**
       * Название иконки
       */
      type: String as PropType<TCdsIconsName>,
      default: undefined,
      validator: (value: TCdsIconsName) => CdsIcons.allowedIcons.includes(value)
    },
    ...makeSizeProps(),
    ...makeInvertColor(),
    ...makeThemeProps()
  },
  emits: [],
  setup(props) {
    const { sizeClasses } = useSize(props, componentName);
    const { invertColorClasses } = useInvertColor(props, componentName);
    const { themeClasses } = provideTheme(props);

    if (props.name) {
      const iconComponent = computed(() => 'Icon' + pascalCase(props.name as string));

      return {
        iconComponent,
        sizeClasses,
        themeClasses,
        invertColorClasses
      };
    } else {
      return {
        sizeClasses,
        themeClasses,
        invertColorClasses
      };
    }
  }
});
</script>

<template>
  <i class="cds-icon" :class="[sizeClasses, themeClasses, invertColorClasses]">
    <component :is="iconComponent" v-if="name" />
    <!--
      @slot Слот для иконки
        @type svg
    -->
    <slot />
  </i>
</template>

<style lang="scss">
@import './CdsIcon';
</style>
